import React from "react";
import styles from "./GalleryCard.module.scss";
import galleryImage from "../../../assets/images/gallery-image.jpg";

const GalleryCard = () => {
  return (
    <div className={styles.card} onClick={() => console.log("Card clicked.")}>
      <div className={styles.mainImage}>
        <img src={galleryImage} alt="Gallery Name" />
      </div>
      <div className={styles.otherImages}>
        <div>
          <img src={galleryImage} alt="Gallery Name" />
        </div>
        <div>
          <img src={galleryImage} alt="Gallery Name" />
        </div>
        <div>
          <img src={galleryImage} alt="Gallery Name" />
        </div>
      </div>
      <h2 className={styles.title}>Gallery Name</h2>
    </div>
  );
};

export default GalleryCard;
